import { useIntl } from 'react-intl';
import { format, isToday, isYesterday } from 'date-fns';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import {
  DealerInitial,
  DisplayName,
  NameContainer,
  NegotiationDate,
  ProposalDisplayContainer
} from './Styles';

const ProposalDisplay = ({ isSellContext, proposal }) => {
  const intl = useIntl();
  const user = useSelector(state => state?.auth?.user, shallowEqual);
  const isCsu = user?.superUserId && user?.superUserId !== user?.id;

  const formatNegotiationDate = time => {
    const date = new Date(time);
    let formatString;
    if (isToday(date)) {
      formatString = intl.formatMessage({
        id: 'modal.negotiation.offer.today'
      });
    } else if (isYesterday(date)) {
      formatString = intl.formatMessage({
        id: 'modal.negotiation.offer.yesterday'
      });
    } else {
      formatString = intl.formatMessage({
        id: 'modal.negotiation.offer.someDay'
      });
    }
    return format(new Date(time), formatString);
  };

  const getProposalDisplayName = userProposal => {
    // Never showing buyer name to the seller
    const isBuyerProposalToSeller = isSellContext && !userProposal.isUserSeller;
    if (isBuyerProposalToSeller) {
      return isCsu
        ? [userProposal.userInitials, userProposal.fullName]
        : [
            null,
            intl.formatMessage({
              id: 'list.card.negotiation.proposals.buyer'
            })
          ];
    }
    return [userProposal.userInitials, userProposal.fullName];
  };

  const [initial, displayName] = getProposalDisplayName(proposal);

  return (
    <ProposalDisplayContainer>
      <NameContainer>
        {initial && <DealerInitial>{initial}</DealerInitial>}
        <DisplayName>{displayName}</DisplayName>
      </NameContainer>
      <NegotiationDate>{formatNegotiationDate(proposal.time)}</NegotiationDate>
    </ProposalDisplayContainer>
  );
};

export default ProposalDisplay;
